import type { EbookRankingQuery } from '@wx-weiqi/contracts';

type CalendarPeriod = Exclude<EbookRankingQuery['period'], 'BOOK'>;
const dayMs = 86_400_000;
export function beijingDay(now = new Date()) {
  return new Date(now.getTime() + 8 * 3_600_000).toISOString().slice(0, 10);
}
export function rankingCalendar(period: CalendarPeriod, day: string) {
  const date = new Date(`${day}T00:00:00Z`);
  if (period === 'MONTH') date.setUTCDate(1);
  else date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));
  const start = date.toISOString().slice(0, 10);
  if (period === 'MONTH') date.setUTCMonth(date.getUTCMonth() + 1);
  else date.setUTCDate(date.getUTCDate() + 7);
  return { start, end: new Date(date.getTime() - dayMs).toISOString().slice(0, 10) };
}
export function shiftRankingPeriod(period: CalendarPeriod, day: string, direction: -1 | 1) {
  const date = new Date(`${rankingCalendar(period, day).start}T00:00:00Z`);
  if (period === 'MONTH') date.setUTCMonth(date.getUTCMonth() + direction);
  else date.setUTCDate(date.getUTCDate() + direction * 7);
  return date.toISOString().slice(0, 10);
}
export function rankingPeriodLabel(period: CalendarPeriod, day: string) {
  const range = rankingCalendar(period, day);
  return period === 'MONTH'
    ? `${range.start.slice(0, 4)} 年 ${Number(range.start.slice(5, 7))} 月`
    : `${range.start.replaceAll('-', '.')} — ${range.end.slice(5).replace('-', '.')}`;
}
/** Reserve readable headings, personal metrics and paging controls before allocating rows. */
export function rankingVisibleRows(width: number, contentHeight: number) {
  const available =
    width <= 720 ? (contentHeight - 410) / 112 : (contentHeight - (width <= 1190 ? 270 : 235)) / 54;
  return Math.max(1, Math.min(6, Math.floor(available)));
}
